
import Job from './job.vue'
export default {
  components: {Job},
  props: {
    jobs: {type: Array, default: () => []},
  },
  computed: {
    split_index(){
      return Math.ceil(this.jobs.length / 2)
    },
    first_col(){
      return this.jobs.slice(0, this.split_index)
    },
    second_col(){
      return this.jobs.slice(this.split_index)
    }
  },
}
